export default __webpack_public_path__ + "static/media/influencerPlaceholder.dfb7d8ee.png";